// src/components/Layout.js
import React from "react";
import { Outlet } from "react-router-dom";
import SiteHeader from "./siteHeader";

const Layout = () => {
  return (
    <>
      <SiteHeader />
      <Outlet />
    </>
  );
};

export default Layout;
